import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";

import { HelmetProvider } from 'react-helmet-async';

// Your custom hook for affiliate tracking
import useAffiliateTracker from './hooks/useAffiliateTracker';

import Header from "../src/Components/Header/Navbar";
import Footer from "../src/Components/Footer/Footer";
import ScrollToTop from "./Components/ScrollButton/ScrollToTop";
import Popup from "./Components/PopupBanner/Popup";
import { Toaster } from "react-hot-toast";

// Import Home directly (not lazy loaded) since it has its own custom loader
import Home from "../src/Pages/Home";

// This helper function is great, no changes needed here.
const lazyWithMinTime = (factory, minTime = 500) => {
  return React.lazy(() =>
    Promise.all([
      factory(),
      new Promise((resolve) => setTimeout(resolve, minTime)),
    ]).then(([moduleExports]) => moduleExports)
  );
};

// Lazy loaded pages
const About = lazyWithMinTime(() => import("../src/Pages/About"));
const Shop = lazyWithMinTime(() => import("../src/Pages/Shop"));
const Contact = lazyWithMinTime(() => import("../src/Pages/Contact"));
const Blog = lazyWithMinTime(() => import("../src/Pages/Blog"));
const ProductDetails = lazyWithMinTime(() => import("./Pages/ProductDetails"));
const NotFound = lazyWithMinTime(() => import("./Pages/NotFound"));
const Authentication = lazyWithMinTime(() => import("./Pages/Authentication"));
const ResetPass = lazyWithMinTime(() => import("./Components/Authentication/Reset/ResetPass"));
const BlogDetails = lazyWithMinTime(() => import("./Components/Blog/BlogDetails/BlogDetails"));
const TermsConditions = lazyWithMinTime(() => import("./Pages/TermsConditions"));
const ShoppingCart = lazyWithMinTime(() => import("./Components/ShoppingCart/ShoppingCart"));
const Wishlist = lazyWithMinTime(() => import("./Components/ShoppingCart/Wishlist"));
// --- 1. IMPORT YOUR NEW GIFT CARD PAGE ---
const GiftCard = lazyWithMinTime(() => import("./Pages/GiftCard"));


// A visually improved loader component for Suspense fallback
const PageLoader = () => (
  <div className="page-loader">
    <div className="spinner"></div>
    <p>LOADING...</p>
  </div>
);

// --- NEW COMPONENT TO HANDLE THE AFFILIATE TRACKING LOGIC ---
// This component will live *inside* the BrowserRouter, so it can use router hooks.
const AffiliateTracker = () => {
  // Now this hook is called in the correct context.
  useAffiliateTracker();
  // This component doesn't need to render anything visual.
  return null;
};


const App = () => {
  // We REMOVE the hook call from here.
  // useAffiliateTracker(); 

  return (
    <HelmetProvider>
      <BrowserRouter>
        {/* --- ADD THE NEW COMPONENT HERE --- */}
        <AffiliateTracker />
        
        <Popup />
        <ScrollToTop />
        <Header />
        
        {/* Use one Suspense component to wrap all lazy-loaded routes */}
        <Suspense fallback={<PageLoader />}>
          <Routes>
            {/* Home route is not lazy, so it loads instantly */}
            <Route path="/" element={<Home />} />

            {/* All lazy-loaded routes go here */}
            <Route path="/about" element={<About />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            {/* --- 2. ADD THE ROUTE FOR YOUR NEW PAGE --- */}
            <Route path="/gift-card" element={<GiftCard />} />
            <Route path="/product/:productId" element={<ProductDetails />} />
            <Route path="/loginSignUp" element={<Authentication />} />
            <Route path="/resetPassword" element={<ResetPass />} />
            <Route path="/blog/:slug" element={<BlogDetails />} />
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/cart" element={<ShoppingCart />} />
            <Route path="/wishlist" element={<Wishlist />} />
            
            {/* The catch-all 404 route must be last */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        
        <Footer />
        <Toaster />
      </BrowserRouter>
    </HelmetProvider>
  );
};

export default App;